import { render, staticRenderFns } from "./CalculatePrice.vue?vue&type=template&id=2ba84d12&scoped=true&"
import script from "./CalculatePrice.vue?vue&type=script&lang=js&"
export * from "./CalculatePrice.vue?vue&type=script&lang=js&"
import style0 from "./CalculatePrice.vue?vue&type=style&index=0&id=2ba84d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba84d12",
  null
  
)

export default component.exports